import Api from '../Api';

import { url } from './config';
import { Queue } from './types';

const api = new Api<Queue>(url);

export default api;
